// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import CompanyList from "../../containers/companies/CompanyAdminList";
import { companyDialogMessages } from "../../../account/components/companies/CompileCompanytoJson";
import {
  fetcCompanyList,
  fetchTierList
} from "../../actions/companyAdminActions";
import { fetctAllUsers } from "../../actions/userAdminActions";
import { fetchProductSheetList } from "../../actions/quoteAdminActions";
import { StyledSelect, LoadingProgress, SnackbarMessage, SingleSwitch, NoItem } from "imagus-components";
import ChipInput from "../../../global/components/ChipInput";
import {
  propComparator,
  propCompare
} from "../../../global/functions/StringOperations";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

type AdminCompaniesStateType = {
  isFilterOpen: boolean,
  order: | "updateDate"
         | "companyName"
         | "licenceCount"
         | "facebaseCount"
         | "userCount",
  suquence: "asc" | "desc",
  searches: Array<string>,
  companyType: string,
  tierType: string,
  priceType: string,
  billType: string,
  messageId: number,
  snackOpen: boolean
};

class AdminCompanies extends Component<*, AdminCompaniesStateType> {
  constructor(props) {
    super(props);
    this.state = {
      isFilterOpen: true,
      order: "companyName",
      suquence: "asc",
      searches: [],
      companyType: "ALL",
      tierType: "ALL",
      priceType: "ALL",
      billType: "ALL",
      messageId: 0,
      snackOpen: false
    };
  }

  componentDidMount() {
    if (this.props.companies === null) {
      this.props.actions.fetcCompanyList();
    }
    if (this.props.userList === null) {
      this.props.actions.fetctAllUsers();
    }
    if (this.props.tiers === null) {
      this.props.actions.fetchTierList();
    }
    if (this.props.productSheets === null) {
      this.props.actions.fetchProductSheetList();
    }
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  openSnackbar = (messageId: number): * => {
    this.setState(
      { messageId: messageId },
      this.switchModalStatus("snackOpen")(true)
    );
  };

  updateSearches = (list: Array<string>): * => {
    let searches = [...this.state.searches];
    for (let i = 0; i < list.length; i++) {
      if (searches.indexOf(list[i]) < 0) {
        searches.push(list[i]);
      }
    }
    this.setState({ searches: searches });
  };

  handleTypeChange = (e: Event): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };

  syncChange = (name: string, value: Array<*>): * => {
    this.setState({ [name]: value });
  };

  handleSwitchChange = (event: Event): * => {
    const name = event.target.name;
    const value = event.target.checked;
    this.setState({
      [name]: value
    });
  };

  render(): * {
    const companies = this.props.companies && [...this.props.companies];
    let companyNode = null;
    let SearchList = [];

    if (companies) {
      if (companies.length === 0) {
        companyNode = <NoItem content="No Company has created yet." />;
      } else {
        if (this.state.order === "updateDate") {
          companies.sort(
            propComparator("lastUpdatedDate", false, null, null, true)
          );
        } else if (this.state.order === "companyName") {
          companies.sort(propComparator("name", true));
        } else if (this.state.order === "licenceCount") {
          companies.sort(function(a: *, b: *): * {
            let alicenceCount = a.licences.edges && a.licences.edges.length;
            let blicenceCount = b.licences.edges && b.licences.edges.length;
            return propCompare(alicenceCount, blicenceCount);
          });
        } else if (this.state.order === "facebaseCount") {
          companies.sort(function(a: *, b: *): * {
            let afaceCount = a.facebases.edges && a.facebases.edges.length;
            let bfaceCount = b.facebases.edges && b.facebases.edges.length;
            return propCompare(afaceCount, bfaceCount);
          });
        } else if (this.state.order === "userCount") {
          companies.sort(function(a: *, b: *): * {
            let auserCount = a.users.edges && a.users.edges.length;
            let buserCount = b.users.edges && b.users.edges.length;
            return propCompare(auserCount, buserCount);
          });
        }

        if (this.state.suquence === "desc") {
          companies.reverse();
        }

        let companyList = [];
        for (let i = 0; i < companies.length; i++) {
          SearchList.push({ value: companies[i].id, label: companies[i].name });
          companyList.push(companies[i]);
        }
        SearchList.sort(propComparator("label", true));

        companyNode = (
          <CompanyList
            companies={companyList}
            updateSearches={this.updateSearches}
            openSnackbar={this.openSnackbar}
            companyFilter={this.state.searches}
            typeFilter={this.state.companyType}
            tierFilter={this.state.tierType}
            priceFilter={this.state.priceType}
            billFilter={this.state.billType}
          />
        );
      }
    }

    const OrderList = [
      { value: "companyName", label: "Company Name" },
      { value: "updateDate", label: "Last Updated Date" },
      { value: "licenceCount", label: "Licence Number" },
      { value: "facebaseCount", label: "Facebase Number" },
      { value: "userCount", label: "User Number" }
    ];
    const SequenceList = [
      { value: "asc", label: "Ascending" },
      { value: "desc", label: "Descending" }
    ];
    const TypeList = [
      { value: "ALL", label: "ALL" },
      { value: "D", label: "Distributor" },
      { value: "A", label: "Authorised Reseller" },
      { value: "S", label: "Standard Reseller" },
      { value: "E", label: "End User" }
    ];

    let TierList = [{ value: "ALL", label: "ALL" }];
    this.props.tiers &&
      this.props.tiers.map(
        (tier: { [key: string]: string }): * => {
          TierList.push({
            value: tier.id,
            label: tier.name
          });
        }
      );

    let PriceList = [{ value: "ALL", label: "ALL" }];
    this.props.productSheets &&
      this.props.productSheets.map(
        (productSheet: { [key: string]: string }): * => {
          PriceList.push({
            value: productSheet.id,
            label: productSheet.description
          });
        }
      );

    const BillList = [
      { value: "ALL", label: "ALL" },
      { value: "CLOUD", label: "Online Billing Company" }
    ];

    if (!companyNode) {
      return (
        <div className="app-panel">
          <LoadingProgress />
        </div>
      );
    } else {
      return (
        <div className="app-panel">
          <SnackbarMessage
            open={this.state.snackOpen}
            handleModalStatus={this.switchModalStatus("snackOpen")}
            message={companyDialogMessages[this.state.messageId]}
          />
          <div className="app-panel-content">
            <Paper elevation={4} style={{ padding: "16px " }}>
              <SingleSwitch
                value={this.state.isFilterOpen}
                name="isFilterOpen"
                isRequired={false}
                label={["Show Criteria", "Hide Criteria"]}
                handleChange={this.handleSwitchChange}
              />
              {this.state.isFilterOpen && (
                <Grid container spacing={24}>
                  <Grid item xs={12} md={6}>
                    <StyledSelect
                      value={this.state.order}
                      onChange={this.handleTypeChange}
                      name="order"
                      label="Order By"
                      isRequired={true}
                      menus={OrderList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <StyledSelect
                      value={this.state.suquence}
                      onChange={this.handleTypeChange}
                      name="suquence"
                      label="Ascend | Descend"
                      isRequired={true}
                      menus={SequenceList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={6} className="top-margin-10">
                    <ChipInput
                      name="searches"
                      label="Select Companies"
                      isMultiple
                      placeholder="All Companies"
                      tags={SearchList}
                      value={this.state.searches}
                      syncChange={this.syncChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <StyledSelect
                      value={this.state.companyType}
                      onChange={this.handleTypeChange}
                      name="companyType"
                      label="Company Type"
                      isRequired={true}
                      menus={TypeList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <StyledSelect
                      value={this.state.tierType}
                      onChange={this.handleTypeChange}
                      name="tierType"
                      label="Tier Type"
                      isRequired={true}
                      menus={TierList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <StyledSelect
                      value={this.state.priceType}
                      onChange={this.handleTypeChange}
                      name="priceType"
                      label="Quote Price Type"
                      isRequired={true}
                      menus={PriceList}
                      isStyled
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <StyledSelect
                      value={this.state.billType}
                      onChange={this.handleTypeChange}
                      name="billType"
                      label="Online Billing Type"
                      isRequired={true}
                      menus={BillList}
                      isStyled
                    />
                  </Grid>
                </Grid>
              )}
            </Paper>
          </div>
          {companyNode}
        </div>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  companies: state.v3admin.company.companies,
  userList: state.v3admin.user.users,
  tiers: state.v3admin.company.tiers,
  productSheets: state.v3admin.quote.productSheets
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    { fetcCompanyList, fetctAllUsers, fetchTierList, fetchProductSheetList },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCompanies);
